import {ALERT_MSG_TYPE} from './alertFactory.service';
import {IGeneralAlertMsg} from './alertMsg.interface';

export class GeneralAlertMsg implements  IGeneralAlertMsg{
	private _htmlMsg 		:string = null;
	private _alwaysOn 		:boolean = false;
	private _msgValues : object = {}

	constructor(private type:ALERT_MSG_TYPE, private dismissed?:Object){
	}

	public show(html, alwaysOn = false ,msgValues = {}){
		this._htmlMsg = html;
		this._alwaysOn = alwaysOn;
		this._msgValues = msgValues;
	}

	public hide(){
		this._htmlMsg = null;
	}


	public getMsgHtml(){
		return this._htmlMsg;
	}

	public getMsgValues(){
		return this._msgValues;
	}

	public getType(){
		return this.type;
	}

	public isDissmissed(){
		return this.dismissed[this.type];
	}
	
	public getAlwaysOn() {
		return this._alwaysOn;
	}


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/generalAlertMsg.ts